import * as React from 'react';
export var IconChevronRight = React.forwardRef(function IconChevronRight({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M6.237 11.801a.75.75 0 0 1-.042-1.06L8.725 8l-2.53-2.741a.75.75 0 0 1 1.102-1.017l3 3.25a.75.75 0 0 1 0 1.017l-3 3.25a.75.75 0 0 1-1.06.043Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M10.266 17.82a.75.75 0 0 1-.081-1.058l4.08-4.76-4.084-4.761a.75.75 0 1 1 1.138-.977l4.504 5.25a.75.75 0 0 1 0 .977l-4.5 5.247a.75.75 0 0 1-1.057.081Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M10.266 17.82a.75.75 0 0 1-.081-1.058l4.08-4.76-4.084-4.761a.75.75 0 1 1 1.138-.977l4.504 5.25a.75.75 0 0 1 0 .977l-4.5 5.247a.75.75 0 0 1-1.057.081Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
